import { Injectable } from '@angular/core';
declare var ga: Function;

@Injectable()
export class GoogleAnalyticsService {

    constructor() {
        void (0);
    }

    public trackLoginEvent(userId: string) {
        ga('set', 'userId', userId);
        ga('set', 'dimension1', userId);
        this.trackEvent('login', 'login', 'login')
    }

    public trackPageView(page: string) {
        ga('set', 'page', page);
        ga('send', 'pageview');
    }

    public trackEvent(
        eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null,
        customDimensions?: any) {

        if (customDimensions) {
            ga('set', customDimensions);
        }

        const event = {
            'eventCategory': eventCategory,
            'eventAction': eventAction,
            'eventLabel': eventLabel,
            'eventValue': eventValue != null && eventValue != undefined ? eventValue : 0
        }

        ga('send', 'event', event);

        if (customDimensions) {
            Object.keys(customDimensions).forEach(k => customDimensions[k] = null);
            ga('set', customDimensions);
        }
    }

    public trackTiming(
        timingCategory: any,
        timingVar: any,
        timingLabel: any,
        timingValue: any,
        customDimensions?: any
    ) {
        if (customDimensions) {
            ga('set', customDimensions);
        }

        ga('send', 'timing', {
            'timingCategory': timingCategory,
            'timingVar': timingVar,
            'timingValue': timingValue,
            'timingLabel': timingLabel
        });

        if (customDimensions) {
            Object.keys(customDimensions).forEach(k => customDimensions[k] = null);
            ga('set', customDimensions);
        }
    }

    public trackException(exDescription: any, exFatal: any) {
        ga('send', 'exception', {
            'exDescription': exDescription,
            'exFatal': exFatal
        });
    }

    public trackErrorEvent(eventCategory: any, eventAction: any, eventLabel: any, eventValue: any, errorCode: any, method: any, data: any) {
        ga('set',
            {
                'dimension2': errorCode,
                'dimension3': method,
                'dimension4': data
            });

        ga('send', 'event',
            {
                'eventCategory': eventCategory,
                'eventAction': eventAction,
                'eventLabel': eventLabel,
                'eventValue': eventValue != null && eventValue != undefined ? eventValue : 0
            });

        ga('set',
            {
                'dimension2': null,
                'dimension3': null,
                'dimension4': null
            });

    }
}
